import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallTouch,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';
import { useRoomLimit } from '~teacher/components/rooms/useRoomLimit';
import { useMaxRosterSize } from '~teacher/hook/room/useMaxRosterSize';

export type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  paywallTouch: PaywallTouch;
};

export function MaxRoomsPaywall({ paywallTouch, ...props }: Props) {
  const roomLimit = useRoomLimit();
  return (
    <ShortPaywall
      paywallTouch={paywallTouch}
      title={translate('You’ve Reached Your {0} Room Limit').format(
        roomLimit.data
      )}
      body={translate('Upgrade to unlock more rooms.')}
      {...props}
    />
  );
}

export function MaxStudentsInRosterPaywall({ paywallTouch, ...props }: Props) {
  const maxStudentsInRoom = useMaxRosterSize();
  return (
    <ShortPaywall
      paywallTouch={paywallTouch}
      title={translate('You’ve Reached Your {0} Student Limit').format(
        maxStudentsInRoom.data
      )}
      body={translate('Upgrade to add more students.')}
      {...props}
    />
  );
}

type ShortPaywallProps = {
  paywallTouch: PaywallTouch;
  title: string;
  body: string;
} & Pick<DialogProps, 'open' | 'onClose'>;

function ShortPaywall({
  paywallTouch,
  title,
  body,
  onClose,
  ...props
}: ShortPaywallProps) {
  return (
    <PaywallDialog.Short
      actions={[
        <UIButton key="cancel" onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={paywallTouch[0]}
        />,
      ]}
      onClose={onClose}
      closeLabel={translate('Close')}
      id={'short-rooms-paywall'}
      title={title}
      paywallTouch={paywallTouch}
      {...props}
    >
      {body}
    </PaywallDialog.Short>
  );
}
